import isPropValid from '@emotion/is-prop-valid'
import { ShouldForwardProp } from 'styled-components'

// styled-components v6 forwards all props by default. This restores the default behaviour of v5. Moving forward we
// should use transient props (see https://styled-components.com/docs/api#transient-props)
const shouldForwardProp: ShouldForwardProp<'web'> = (propName, target) =>
  typeof target !== 'string' || isPropValid(propName)

export default shouldForwardProp
